// src/stores/Factors.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";

export const useFactorsStore = defineStore("Factors", () => {
    const FactorEntity = ref({});
    const loading = ref(false);
    const toast = useToast();
    async function fetchFactor(doctorId, factorNo) {
        try {

            const response = await apiClient.get(`/Factor/${doctorId},${factorNo}`);
            console.log(response.data)
            if (response.data) {
                FactorEntity.value = response.data;
            }
            else {
                FactorEntity.value = {};
                toast.info("با توجه به شماره قبض اطلاعاتی یافت نشد");
            }
        } catch (error) {
            console.error("Error fetching patients:", error);
            FactorEntity.value = {};
            toast.error("خطا در ارتباط با سرور");
        }
    }
    async function CancelInvoice(factorid) {
        try {

            const response = await apiClient.get(`/Factor/CancelInvoice/${factorid}`);
            console.log(response.data)
            if (response.status === 200) {
                toast.success("قبض با موفقیت ابطال شد");
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error("Error fetching patients:", error);
            FactorEntity.value = {};
            toast.error("خطا در ارتباط با سرور");
        }
    }
    async function addFactor(FactorData) {
        try {
            const response = await apiClient.post('Factor/', FactorData);
            if (response.status === 200) {
                toast.success("قبض با موفقیت ثبت شد");
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error("Error adding Factor:", error);
        } finally {
            loading.value = false;
        }
    }

    async function updateFactor(data) {
        try {
            const response = await apiClient.put("/Factor", data);
            if (response.status === 200) {
                toast.success("اطلاعات قبض با موفقیت ویرایش شد");
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.error("Error updating Factor:", error);
        }
    }

    async function deleteFactor(id) {
        loading.value = true;
        try {
            const response = await apiClient.delete(`/Factor/${id}`);
            if (response.status === 200) {
                toast.success("قبض با موفقیت حذف شد");
            } else {
                toast.error("خطا در حذف قبض");
            }
        } catch (error) {
            toast.error("خطا در حذف قبض");
        } finally {
            loading.value = false;
        }
    }

    async function deleteFactorItem(id) {
        loading.value = true;
        try {
            const response = await apiClient.delete(`/Factor/DeleteItem/${id}`);
            if (response.status === 200) {
                toast.success("اقلام فاکتور با موفقیت حذف شد");
            } else {
                toast.error("خطا در حذف اقلام فاکتور");
            }
        } catch (error) {
            toast.error("خطا در حذف اقلام فاکتور");
        } finally {
            loading.value = false;
        }
    }
    async function GetMaxFactorNumber(doctorId) {
        try {
            // Pass doctorId as a query parameter if provided.
            const url = doctorId ? `/Factor/GetMaxFactorNumber?doctorId=${doctorId}` : "/Factor/GetMaxFactorNumber";
            const response = await apiClient.get(url);
            if (response && response.status === 200 && response.data !== undefined && response.data !== null) {
                return response.data.toString();
            } else {
                toast.error("خطا در دریافت اطلاعات شماره پرسنلی");
                return null;
            }
        } catch (error) {
            console.error("Error fetching Max Factor Number:", error);
            toast.error("خطا در دریافت اطلاعات شماره پرسنلی");
            return null;
        }
    }

    return {
        FactorEntity,
        fetchFactor,
        addFactor,
        updateFactor,
        deleteFactor,
        CancelInvoice,
        deleteFactorItem,
        GetMaxFactorNumber
    };
});
